// import { fetchAuthSession } from 'aws-amplify/auth'
import { getAuthToken } from '../../../utils/functions.utils'
import React, { useState, createContext, useContext, ReactNode } from 'react'
import { request_gamification_history, request_gamification_ranking, request_get_gamification } from '../../../services/gamification.services'
import { request_get_games, request_ranking, request_save_game } from '../../../services/trivia.services'
import { GAMIFICATION_STATUS_KEYS, GAMIFICATION_TYPES_KEYS } from '../constants/constants.gamification'
import { resetCache } from '../../../utils/FetchServices'
import { getImageStogeUrl } from '../../imageUploader/ImageStorage'
import { downloadAndUnzipAllFiles, downloadAvatarUser, getAvatarUser } from '../../../utils/functions.utils'
import { getGlobalVersion, getUser, openDB, updateGlobalVersion } from '../../../db/indexDB'
import { getAvatarPlaceholderLocal, avatarPlaceholder } from '../../customUtils/Constants'
import { UserServices } from '../../../../database/user.database'
import { GAMIFICATION_STORE_NAMES } from '../../../db/gamification'
import { GamificationServices } from '../../../../database/gamification.database'
import { GamificationDefaultBackgroundGradient } from '../../../../themeConstants'

const GamificationContext = createContext()

export const GamificationProvider = ({ children }) => {
    const [mapLoading, setMapLoading] = useState(true)
    const [gamificationData, setGamificationData] = useState({ levels: [], points: 0, userLevel: 0 })
    const [lastScrolledLevel, setLastScrolledLevel] = useState('')
    const [currentLevel, setCurrentLevel] = useState(null)
    const [games, setGames] = useState([])
    const [rouletteColors, setRouletteColors] = useState([])
    const [avatarUrl, setAvatarUrl] = useState(avatarPlaceholder)
    const [backgroundGradient, setBackgroundGradient] = useState(GamificationDefaultBackgroundGradient)
    const [ranking, setRanking] = useState([])
    const [history, setHistory] = useState([])
    const [parallaxImages, setParallaxImages] = useState([])
    const [mapHasRendered, setMapHasRendered] = useState(null)
    const [selectedCategory, setSelectedCategory] = useState(null) // Almacena la categoría seleccionada en la ruleta
    const [showRoulette, setShowRoulette] = useState(false)
    const [currentAnimatedIndex, setCurrentAnimatedIndex] = useState(null)

    const fetchData = async () => {
        try {
            let newLevel = 0
            // getUserData()
            const authToken = await getAuthToken()
            if (!authToken) return

            try {
                const db = await openDB()

                let version = '0'
                const gamificationVersion = await getGlobalVersion(db, GAMIFICATION_STORE_NAMES.GAMIFICATION_VERSION)
                if (gamificationVersion != null) {
                    version = gamificationVersion
                }

                const { levels, points, zip_assets, userLevel, parallax, newVersion } = await request_get_gamification({ authToken, version })
                if (version != newVersion) {
                    await setMapForUpdate()
                    updateGlobalVersion(db, GAMIFICATION_STORE_NAMES.GAMIFICATION_VERSION, newVersion)
                }
                if (levels.length > 0) {
                    let levelIndex = levels.findIndex((step) => step.status === GAMIFICATION_STATUS_KEYS.PENDING)
                    newLevel = levels[levelIndex]._id
                }
                if (zip_assets != null) {
                    if (zip_assets.gradient && zip_assets.gradient.length > 0) {
                        setBackgroundGradient(zip_assets.gradient)
                    }

                    if (zip_assets.zip_url != null && zip_assets.zip_url != '') {
                        let currentZipVersion = await getGlobalVersion(db, 'gamification_zip')
                        // console.log('currentZipVersion', currentZipVersion)
                        let newZipVersion = zip_assets.metadata?.version || '0'
                        if (currentZipVersion === null || (currentZipVersion != null && currentZipVersion != newZipVersion)) {
                            // console.log('ENTRO AL IF', currentZipVersion, newZipVersion)
                            let filePath = await downloadAndUnzipAllFiles('gamification', zip_assets.zip_url)
                            // console.log('filePath', filePath)
                            updateGlobalVersion(db, GAMIFICATION_STORE_NAMES.PARALLAX_ZIP_VERSION, newZipVersion)
                        }
                    }
                }
                setParallaxImages(parallax)
                setGamificationData({ levels, points: points, userLevel: userLevel })
            } catch (error) {
                console.log('Error first try', error)
                setMapLoading(false)
            } finally {
                resetCache()
                setCurrentLevel(newLevel)
                // setMapLoading(false)
            }
            try {
                const data = await request_get_games({ authToken, is_gamification: true })
                let games = data.single.games || []
                let colors = data.single.colors || []
                let last_level = data.single.last_level || null
                // console.log('LAST LEVEL:', last_level)
                if (last_level != null) {
                    let level_id = last_level._id || ''
                    let attempts = last_level.intents || 0
                    const db = await openDB()
                    await updateGlobalVersion(db, GAMIFICATION_STORE_NAMES.LEVEL_ATTEMPTS + level_id, attempts)
                    console.log('Intentos del nivel actualizado: ==> ', level_id, attempts)
                }
                setGames(games)
                setRouletteColors(colors)
            } catch (error) {
                console.log(error)
            }
            try {
                const rankingSingle = await request_gamification_ranking({ authToken })
                const positions = rankingSingle.single.ranking ? rankingSingle.single.ranking : []
                setRanking(positions)
            } catch (error) {
                console.log(error)
            }
            try {
                const historyData = await request_gamification_history({ authToken })
                const history = historyData.single.history ? historyData.single.history : []
                setHistory(history)
            } catch (error) {
                console.log(error)
            }
            try {
                await getAndSetAvatarUser()
            } catch (error) {
                console.log(error)
            }
        } catch (e) {
            console.log('Error al obtener los datos de gamificación:', e)
        } finally {
            setMapLoading(false)
        }
    }
    const setMapForUpdate = async () => {
        // console.log('setMapForUpdate called')
        setMapLoading(true)
        setMapHasRendered(false)
        setCurrentAnimatedIndex(0)
    }
    async function scrollUserLevel(newLevel) {
        let scrollToLevel = []
        try {
            const db = await openDB()
            let lastUserLevel = await getGlobalVersion(db, GAMIFICATION_STORE_NAMES.SCROLL_CURRENT_LEVEL)

            if (!lastUserLevel || lastUserLevel === newLevel) {
                scrollToLevel.push(newLevel)
                await updateGlobalVersion(db, GAMIFICATION_STORE_NAMES.SCROLL_CURRENT_LEVEL, newLevel)

                return scrollToLevel
            }
            if (lastUserLevel != newLevel) {
                scrollToLevel.push(lastUserLevel)
                await updateGlobalVersion(db, GAMIFICATION_STORE_NAMES.SCROLL_CURRENT_LEVEL, newLevel)
                scrollToLevel.push(newLevel)
                return scrollToLevel
            }
        } catch (error) {
            console.log('Error al validar el nivel del usuario:', error)
            return [newLevel]
        }
    }
    const getAndSetAvatarUser = async () => {
        const user = await UserServices.getUser()
        if (!user || !user.avatar) {
            return
        }
        const url = await getAvatarUser(user.avatar)
        if (url && url !== null && url !== undefined && url !== '') {
            setAvatarUrl(url)
        } else {
            const url = await getImageStogeUrl(user.avatar)
            if (url && url !== null && url !== undefined && url !== '') {
                setAvatarUrl(url)
                downloadAvatarUser(url, user.avatar)
            }
        }
    }
    const nextStep = (steps) => {
        const newLevel = steps.findIndex((step) => step.status === GAMIFICATION_STATUS_KEYS.PENDING)
        let newSteps = steps.map((step, index) => {
            if (index < newLevel) {
                return { ...step, status: GAMIFICATION_STATUS_KEYS.COMPLETE }
            }
            if (index === newLevel) {
                return { ...step, status: GAMIFICATION_STATUS_KEYS.COMPLETE }
            }
            if (index === newLevel + 1) {
                return { ...step, status: GAMIFICATION_STATUS_KEYS.PENDING }
            }
            return step
        })
        setGamificationData((prevState) => ({
            ...prevState,
            levels: newSteps,
        }))

        // setPrevLevel(currentLevel)
        if (newLevel < 0) {
            setCurrentLevel('')
        } else {
            const newLevelID = steps[newLevel + 1]._id
            setCurrentLevel(newLevelID)
        }
    }
    const getUserData = async () => {
        try {
            const database = await openDB()
            let user = await getUser(database)
            if (user && user.avatar) {
                //@FixMe ==> La imagen no se esta guardando en storage
                // getImageStogeUrl(user.avatar).then((url) => {
                //     if (!url || url === undefined || url === '') {
                //         return
                //     }
                //     setAvatarUrl({ url: url })
                //     downloadAvatarUser(url, user_data?.avatar).then((uri) => {
                //         LoginBiometricsStorage.updateDataBiometricsUser(user_data.user_name, { avatar: uri })
                //     })
                // })
            }
        } catch (error) {
            console.log(error)
        }
    }
    const updateUserLevel = (pointsToSum) => {
        try {
            const steps = gamificationData.levels
            const newPoints = gamificationData.points + pointsToSum

            const newSteps = []
            let foundPending = false
            let gameIncompleteFound = false
            let currentLevel = steps.findIndex((step) => step.status === GAMIFICATION_STATUS_KEYS.PENDING)
            for (let i = 0; i < steps.length; i++) {
                const step = steps[i]
                const isGame = step.type.type === GAMIFICATION_TYPES_KEYS.GAME
                const isComplete = step.status === GAMIFICATION_STATUS_KEYS.COMPLETE
                const hasEnoughPoints = step.points <= newPoints

                if (isComplete) {
                    newSteps.push(step)
                    continue
                }
                if (currentLevel === i) {
                    newSteps.push({ ...step, status: GAMIFICATION_STATUS_KEYS.COMPLETE })
                    continue
                }
                if (gameIncompleteFound || foundPending) {
                    // Ya se puso un pendiente o se encontró un game no hecho → bloquear todo
                    newSteps.push({ ...step, status: GAMIFICATION_STATUS_KEYS.BLOCKED })
                    continue
                }

                if (isGame) {
                    // Primer game sin completar
                    newSteps.push({ ...step, status: GAMIFICATION_STATUS_KEYS.PENDING })
                    foundPending = true
                    gameIncompleteFound = true
                    continue
                }

                if (hasEnoughPoints) {
                    newSteps.push({ ...step, status: GAMIFICATION_STATUS_KEYS.COMPLETE })
                } else {
                    newSteps.push({ ...step, status: GAMIFICATION_STATUS_KEYS.PENDING })
                    foundPending = true
                }
            }
            let userLevel = gamificationData.userLevel
            let newUserLevel = newSteps.findLast(
                (step) => step.type.type === GAMIFICATION_TYPES_KEYS.GAME && step.status === GAMIFICATION_STATUS_KEYS.COMPLETE,
            )
            if (newUserLevel && newUserLevel != undefined) {
                userLevel = newUserLevel.level_text
            }
            setGamificationData((prevState) => ({
                ...prevState,
                levels: newSteps,
                points: newPoints,
                userLevel: userLevel,
            }))
            if (currentLevel < 0) {
                setCurrentLevel('')
            } else {
                let newLevelIndex = newSteps.findIndex((step) => step.status === GAMIFICATION_STATUS_KEYS.PENDING)
                if (newLevelIndex === -1) {
                    setCurrentLevel('')
                } else {
                    const newLevelID = steps[newLevelIndex]._id
                    setCurrentLevel(newLevelID)
                }
            }
        } catch (error) {
            console.log('Error al actualizar el nivel de usuario', error)
        } finally {
            return
        }
    }

    const getPendingGames = async () => {
        let pendingGames = await GamificationServices.getPendingGames()
        // console.log('Pending games:', pendingGames)
        if (pendingGames && pendingGames.length > 0) {
            return pendingGames
        } else {
            return null
        }
    }

    async function searchAndSendPendingGames(firstLoad = false) {
        try {
            let pendingGames = await getPendingGames()
            let successCount = 0
            if (pendingGames && pendingGames.length > 0) {
                const session = await fetchAuthSession()
                const authToken = session.tokens?.accessToken?.toString()

                for (let i = 0; i < pendingGames.length; i++) {
                    const { game_id, body, level_id, status } = pendingGames[i]
                    const jsonBody = JSON.parse(body)
                    try {
                        const data = await request_save_game({ authToken, game_id, body: jsonBody, level_id, status })

                        if (data?.status === 1) {
                            await GamificationServices.deleteGameById(game_id, level_id)
                            successCount++
                        }
                    } catch (err) {
                        console.log(`Error al enviar el juego con ID ${game_id}:`, err)
                    }
                }

                console.log(`Se enviaron correctamente ${successCount} de ${pendingGames.length} juegos pendientes.`)
            } else {
                console.log('No hay juegos pendientes para enviar')
            }
            if (successCount > 0 || firstLoad === true) {
                if (successCount > 0) {
                    setMapLoading(true)
                }
                fetchData()
            }
        } catch (error) {
            console.log('Error al buscar juegos pendientes:', error)
        }
    }
    async function getUserAttempts(level_id) {
        try {
            const db = await openDB()
            const prevAttempts = await getGlobalVersion(db, GAMIFICATION_STORE_NAMES.LEVEL_ATTEMPTS + level_id)
            if (prevAttempts === null || prevAttempts === undefined) {
                return 0
            }
            return prevAttempts
        } catch (error) {
            console.log('Error al obtener los intentos del usuario para el nivel:', level_id, error)
            return 0
        }
    }
    async function updateLevelAttempts(level_id, reset = false) {
        try {
            let prevAttempts = await getUserAttempts(level_id)
            if (prevAttempts === null || prevAttempts === undefined) {
                prevAttempts = 0
            }
            // console.log('Previous attempts for level ==>', level_id, ':', prevAttempts)
            prevAttempts += 1
            // console.log('Updated attempts for level ==>', level_id, ':', prevAttempts)
            if (reset === true) prevAttempts = 0
            const db = await openDB()
            await updateGlobalVersion(db, GAMIFICATION_STORE_NAMES.LEVEL_ATTEMPTS + level_id, prevAttempts)
        } catch (error) {
            console.log('Error al actualizar los intentos del nivel:', level_id, error)
        }
    }
    async function setGameQuestions(category) {
        try {
            let usedQuestionsIDS = await getUsedQuestions(category._id)
            // console.log('IDs de preguntas utilizadas:', usedQuestionsIDS)
            const allQuestions = category.questions || []
            let newQuestions = allQuestions.filter((question) => !usedQuestionsIDS.includes(String(question._id).trim())) // Filtro preguntas no utilizadas
            if (newQuestions.length === 0) {
                //Si todas las preguntas fueron utilizadas, reinicio
                console.log('Todas las preguntas han sido utilizadas, reiniciando...')
                newQuestions = allQuestions
                usedQuestionsIDS = [] // Reinicio el array de IDs utilizados
            }
            newQuestions = newQuestions.sort(() => Math.random() - 0.5) // Mezclo las preguntas
            const count = category.count ? Number(category.count) : 0
            // console.log('Cantidad de preguntas a seleccionar:', count)
            if (count > 0) {
                newQuestions = newQuestions.slice(0, count) // Limitar a la cantidad de preguntas correspondientes
            }
            // Validar que si mi cantidad de preguntas, es menor al count, volver a agregar preguntas del set original
            if (newQuestions.length < count) {
                const pendingCount = count - newQuestions.length
                const additionalQuestions = allQuestions.filter((question) => !newQuestions.includes(question)).slice(0, pendingCount) // Selecciono las preguntas restantes del set original
                newQuestions = newQuestions.concat(additionalQuestions)
            }
            //Guardar los ids de las preguntas utilizadas para no repetirlas
            const newIds = newQuestions.map((question) => question._id)

            usedQuestionsIDS = usedQuestionsIDS.concat(newIds.filter((id) => !usedQuestionsIDS.includes(id)))
            // console.log('IDs de preguntas utilizadas actualizadas:', usedQuestionsIDS)

            // Guardar IDS en base
            const db = await openDB()
            await updateGlobalVersion(db, GAMIFICATION_STORE_NAMES.USED_QUESTIONS_GAME + category._id, JSON.stringify(usedQuestionsIDS))

            return { ...category, questions: newQuestions } // Retornar la categoría con las preguntas actualizadas
        } catch (error) {
            console.log('Error al establecer las preguntas del juego:', error)
            return category
        }
    }
    async function getUsedQuestions(game_id) {
        try {
            const db = await openDB()
            const usedQuestions = await getGlobalVersion(db, GAMIFICATION_STORE_NAMES.USED_QUESTIONS_GAME + game_id)
            if (usedQuestions === null || usedQuestions === undefined) {
                return []
            }
            const mappedIDS = JSON.parse(usedQuestions)
            if (!Array.isArray(mappedIDS)) {
                return []
            }
            // console.log('Used questions for game ID:', game_id, 'are:', mappedIDS)
            return mappedIDS
        } catch (error) {
            console.log('Error al obtener los intentos del usuario para el nivel:', game_id, error)
            return []
        }
    }
    const value = {
        gamificationData,
        fetchData,
        mapLoading,
        currentLevel,
        lastScrolledLevel,
        setLastScrolledLevel,
        nextStep,
        games,
        rouletteColors,
        avatarUrl,
        backgroundGradient,
        updateUserLevel,
        ranking,
        history,
        parallaxImages,
        searchAndSendPendingGames,
        scrollUserLevel,
        mapHasRendered,
        setMapHasRendered,
        selectedCategory,
        setSelectedCategory,
        showRoulette,
        setShowRoulette,
        getUserAttempts,
        updateLevelAttempts,
        setGameQuestions,
        currentAnimatedIndex,
        setCurrentAnimatedIndex,
        setMapForUpdate,
    }
    return <GamificationContext.Provider value={value}>{children}</GamificationContext.Provider>
}
export const useGamification = () => {
    return useContext(GamificationContext)
}
